// extracted by mini-css-extract-plugin
module.exports = {"w6er074":"w6er074","l1chcw6l":"l1chcw6l"};